<template>
  <div style="width: 100%; text-align: left;">
    
      <h1 v-if="$store.getters.getInventoryMasterDataProps.other_variation_item_list.length>0 || ($store.getters.getInventoryMasterDataProps.variant_item_id === 0 
                        && $store.getters.getInventoryMasterDataProps.variant_list.length>0)">Other Variations</h1>
      <el-tag
          v-for="tag in $store.getters.getInventoryMasterDataProps.other_variation_item_list"
          :key="tag.id"
          style="margin-right: 10px; cursor: waiting;">
          {{tag.sku_code}}, {{tag.article_name}}
      </el-tag>

      <hr>
      <br>
      <h3 
        v-if="$store.getters.getInventoryMasterDataProps.other_variation_item_list.length>0 
                && $store.getters.getInventoryMasterDataProps.variant_item_id === 0">Create New Variations</h3>
    
      <el-table
            v-if="$store.getters.getInventoryMasterDataProps.variant_item_id === 0 
                        && $store.getters.getInventoryMasterDataProps.variant_list.length>0"
            :data="$store.getters.getInventoryMasterDataProps.other_variations"
            style="width: 100%">
            
            <el-table-column 
            label="SKU#" width="240">
            <template slot-scope="scope">
              <el-input @focus="$event.target.select()"
                    size="small"
                    placeholder="Leave it blank if not sure"
                    v-model.trim="scope.row.sku_code"
                    style="width: 200px;">                    
                </el-input>
            </template>
            </el-table-column>
            <el-table-column 
            prop="other_variations"
            label="Variations">
            <template slot-scope="scope">
              <el-select 
                  size="small"
                  v-model="scope.row.other_variations"
                  filterable 
                  multiple 
                  style="width: 300px;"
                  placeholder="Select">
                    <el-option-group
                      v-for="dataGroup in $store.getters.getInventoryVariantList"
                      :key="dataGroup.id">
                      <div style="display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start;">
                          <span style="float: left; padding-left: 5px;" v-html="dataGroup.variant_name"></span>
                          <el-option
                              v-for="item in dataGroup.sub_variant_list"
                              :key="item.id"
                              :label="dataGroup.variant_name+' -> '+item.sub_variant_name"
                              :value="item.id">
                              <span style="float: left" v-html="item.sub_variant_name"></span>
                          </el-option>
                      </div>
                    </el-option-group>
              </el-select>
            </template>
            </el-table-column>
            <el-table-column
                fixed="right"
                label="">
                <template slot-scope="scope">
                    <div style="text-align: right; display: flex; flex-direction: row; justify-content: flex-end; align-items: flex-end;">
                        
                        <el-tooltip class="item" effect="dark" content="Add">
                          <a @click="$store.commit('addNewInventoryMasterOtherVariantListRow')" style="cursor: pointer; font-size: 16px;">
                            <i class="el-icon-circle-plus"></i>
                          </a>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="Delete">
                          <el-popconfirm
                              @confirm="$store.commit('removeInventoryMasterOtherVariantListRow', scope.row.key)"
                              title="Are you sure to delete this?"
                              >
                                <a slot="reference" style="cursor: pointer; margin-left: 10px; color: red; font-size: 16px;">
                                  <i class="el-icon-delete"></i>
                                </a>
                              
                          </el-popconfirm>
                        </el-tooltip>
                        
                    </div>                                        
                </template>
            </el-table-column>
        </el-table>
  </div>
</template>

<script>
export default {
    computed: {
      getAllVariants() {
         let list = [];

          JSON.parse(JSON.stringify(this.$store.getters.getInventoryVariantList)).forEach(element => {
              element.sub_variant_list.forEach(variant => {
                  list.push({
                      variant_id: element.id,
                      sub_variant_id: variant.id,
                      sub_variant_name: variant.sub_variant_name,
                  })
              })
          })
         return list
      }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/InventoryMaster/Form/OtherVariant.vue